'use strict';

namespace TR {
    export class InsuranceSearchValidator {
        constructor(
            private resourceService: Core.ResourceService,
            private dateUtil) {

        }

        public validate(policyType, travelDestination, startDate, endDate, occupancy) {
            const errors: string[] = [];

            if (policyType == null) {
                errors.push(this.resourceService.get('SELECTPOLICYTYPE'));
            }

            if (travelDestination == null) {
                errors.push(this.resourceService.get('SELECTTRAVELDESTINATION'));
            }

            if (startDate == null) {
                errors.push(this.resourceService.get('SELECTSTARTDATE'));
            }

            if (endDate == null) {
                errors.push(this.resourceService.get('SELECTENDDATE'));
            }
            else if (endDate <= startDate) {
                errors.push(this.resourceService.get('RETURNDATEAFTERDEPARTUREDATE'));
            }

            if (startDate && endDate &&
                this.dateUtil.compareDates(endDate, this.dateUtil.addDays(startDate, 365, true)) === 1) {
                errors.push(this.resourceService.get('RETURNDATEWITHINONEYEAR'));
            }

            /*  It has been said that breaking nested loops with labels is the worst way to break loops
            except all the others that have been tried.  ~MV */
            /* eslint-disable no-labels */
            childOccupancyLoop:
                for (let ca = occupancy.ChildAges.length - 1; ca >= 0; ca--) {
                    if (occupancy.ChildAges[ca] == null) {
                        errors.push(this.resourceService.get('CHILDAGESERROR'));
                        break childOccupancyLoop;
                    }
                }
            adultOccupancyLoop:
                for (let i = occupancy.AdultAges.length - 1; i >= 0; i--) {
                    if (occupancy.AdultAges[i] == null) {
                        errors.push(this.resourceService.get('ADULTAGESERROR'));
                        break adultOccupancyLoop;
                    }
                }
            /* eslint-enable no-labels */

            return errors;
        }
    }

    angular
        .module('TR')
        .service('insuranceSearchValidator', InsuranceSearchValidator);
}
